import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nx-learn-my-way-svg-sprite',
  templateUrl: './learn-my-way-svg-sprite.component.html',
  styleUrls: ['./learn-my-way-svg-sprite.component.scss']
})
export class LearnMyWaySvgSpriteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
